export default __webpack_public_path__ + "static/media/Paloma.958dc6d0.jpg";